export default __webpack_public_path__ + "static/black-noise-dc640aecc474fc8997a7338d4ba6aebb.gif";